import React from 'react';
import { Link } from 'react-router-dom';

import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Tooltip, Row, Col, Collapse } from 'antd';

import PermissionHide from '../PermissionHide/index';

type FooterProps = {
  hideQuickHelp?: boolean;
  style?: React.CSSProperties;
};

const Footer = ({ hideQuickHelp, style }: FooterProps) => {
  const [show, toggle] = React.useState(false);

  const onClick = () => {
    toggle(!show);
    localStorage.setItem('helper-footer', `${!show}`);
  };

  return (
    <footer id='main-footer' className='mx-auto min-w-full py-4 tracking-normal' style={style}>
      {!hideQuickHelp && (
        <div className='flex justify-center'>
          <Tooltip title='Ajuda Rápida'>
            <Button type='text' className='pt-6 text-center opacity-10'>
              <svg
                onClick={onClick}
                xmlns='http://www.w3.org/2000/svg'
                width='44'
                height='44'
                fill='currentColor'
                viewBox='0 0 16 16'
              >
                {show && (
                  <path
                    fillRule='evenodd'
                    d='M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894l6-3z'
                  />
                )}
                {!show && (
                  <>
                    <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
                    <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
                    <path d='M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z' />
                  </>
                )}
              </svg>
            </Button>
          </Tooltip>
        </div>
      )}

      <Collapse activeKey={show ? ['1'] : []} ghost>
        <Collapse.Panel key='1' header={null} showArrow={false}>
          <div className='border border-solid border-[#ddd]' style={{ padding: 24 }}>
            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <h4 className='mb-0!'>Ajuda rápida com artigos e tutoriais</h4>
                <small>Descubra como fazer qualquer coisa na Eduzz.</small>
                <div className='hidden sm:block'>
                  <PermissionHide action={'myeduzz:ajuda:visualizar'}>
                    <Link className='mt-3 block text-sm text-black/70 underline' to='/producer/help'>
                      Ir para Central de Ajuda
                    </Link>
                  </PermissionHide>
                </div>
              </Col>
              <Col xs={24} sm={12}>
                <form action='https://ajuda.eduzz.com/hc/pt-br/search' method='GET' target='_blank'>
                  <input type='hidden' name='utm_source' value='myeduzz_footer' />
                  <input type='hidden' name='utf8' value='✓' />
                  <Input
                    name='query'
                    type='search'
                    placeholder='como criar um produto físico'
                    prefix={<SearchOutlined />}
                    className='bg-transparent!'
                  />
                  <Button className='mt-3!' htmlType='submit'>
                    Pesquisar
                  </Button>
                </form>
              </Col>
            </Row>
          </div>
        </Collapse.Panel>
      </Collapse>
      <p className='block text-center text-xs text-gray-500'>
        {new Date().getFullYear()} © Eduzz – Todos os direitos reservados
      </p>
    </footer>
  );
};

export default Footer;
